import { render, staticRenderFns } from "./Sessions.vue?vue&type=template&id=050237f8&scoped=true&"
import script from "./Sessions.vue?vue&type=script&lang=js&"
export * from "./Sessions.vue?vue&type=script&lang=js&"
import style0 from "./Sessions.vue?vue&type=style&index=0&id=050237f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050237f8",
  null
  
)

export default component.exports